import { Mask } from '.';
import { FormatFunction } from '..';

export class NameMask extends Mask {
  constructor() {
    super('', 100);
  }

  unformat = (formattedValue: string) => {
    return formattedValue;
  };

  format: FormatFunction = (value, { selectionStart }) => {
    const valueWithoutExtraSpaces = value.replace(/\s+/g, ' ');
    const removeOthersThanLettes = valueWithoutExtraSpaces.replace(
      /[^a-zA-Z\s]/g,
      '',
    );
    return {
      maskedValue: removeOthersThanLettes,
      cursorPosition: selectionStart,
    };
  };
}
